<template lang="pug">
  div
    btn(v-bind:txt="'Отправить'" v-bind:event="'add'")
    btn(:baseClass="'btn-sec'" v-bind:txt="'Вперед'" v-bind:event="'add'")
    // input-field(:placeholder="'Фамилия Имя'" :title="'+7'" :label="'Фамилия, имя и должность контактного лица'" :event="'foobar'")
    div
      // input-check(:id="12" :val="'bar'" :event="'check-test'")
    div
      // input-check(:type="'radio'" :event="'radio-test'" :name="'radio-test'" :val="'foo'")
      // input-check(:type="'radio'" :event="'radio-test'" :name="'radio-test'" :val="'foo1'")
      // input-check(:type="'radio'" :event="'radio-test'" :name="'radio-test'" :val="'foo2'")
    div
      input-select(:isMultiple="true" :options="selectOptions" :input_type="{name: 'dropdown'}")
      br
      br
      br
    div
      // file-upload
</template>

<script>
  import PrimaryButton from '@/components/UI/Button/Button.vue'
  import InputField from '@/components/UI/InputField/InputField.vue'
  import InputTextarea from '@/components/UI/InputTextarea/InputTextarea.vue'
  import CheckboxRadio from '@/components/UI/CheckboxRadio/CheckboxRadio.vue'
  import Select from '@/components/UI/Select/Select.vue';
  import FileUpload from '@/components/UI/FileUpload/FileUpload';

  const selectOptions = [
    { label: '1', value: 1 },
    { label: '2', value: 1 },
    { label: '3', value: 1 },
    { label: '4', value: 1 },
    { label: '5', value: 1 },
    { label: '6', value: 1 },
    { label: '7', value: 1 },
    { label: '8', value: 1 },
    { label: '9', value: 1 },
    { label: '10', value: 1 },
    { label: '11', value: 1 },
    { label: '12', value: 1 },
    { label: '13', value: 1 },
    { label: '14', value: 1 },
    { label: '15', value: 1 },
    { label: '16', value: 1 },
    { label: '17', value: 1 },
    { label: '18', value: 1 },
    { label: '19', value: 1 },
    { label: '20', value: 1 },
    { label: '21', value: 1 },
    { label: '22', value: 1 },
    { label: '23', value: 1 },
    { label: '24', value: 1 },
    { label: '25', value: 1 },
    { label: '26', value: 1 }
  ]

  export default {
    name: 'Main',
    components: {
      'btn': PrimaryButton,
      'input-field': InputField,
      'input-textarea': InputTextarea,
      'input-check': CheckboxRadio,
      'input-select': Select,
      'file-upload': FileUpload
    },
    data () {
      return {
        selectOptions: selectOptions
      }
    }
  }
</script>
